<mat-card>
  <mat-card-header class="full-width-header">
    <mat-card-title>
      <div class="title-row">
        <span>{{ 'AI_ASSISTANT.SETTINGS.TRIGGERS.TITLE' | translate }}</span>
        @if (connectionForms().dirty) {
          <span class="unsaved-changes-text">
            {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
          </span>
        }
      </div>
    </mat-card-title>
    <mat-card-subtitle>{{ 'AI_ASSISTANT.SETTINGS.TRIGGERS.SUBTITLE' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    @if (displayedConnections().length === 0 && blueprintAutomations().length === 0) {
      <div class="empty-state-inline">
        <mat-icon>play_circle</mat-icon>
        <span>{{ 'AI_ASSISTANT.SETTINGS.EMPTY_STATE.NO_TRIGGERS' | translate }}</span>
      </div>
    } @else {
      @for (connectionForm of displayedConnections(); track connectionForm) {
        <glxy-form-field bottomSpacing="none">
          <mat-checkbox
            [formControl]="connectionForm.controls.connected"
            class="connections-checkbox"
            (change)="onConnectionToggle(connectionForm)"
          >
            <div class="checkbox-icon-and-label-wrapper">
              <img [src]="connectionForm.metadata.iconUrl" alt="avatar" class="connection-icon" />
              <div>
                <div>
                  <div>{{ connectionForm.metadata.name }}</div>
                  @if (connectionForm.metadata.hasOtherConnections) {
                    <div class="connection-notice">
                      {{ 'AI_ASSISTANT.SETTINGS.TRIGGERS.EXISTING_TRIGGER' | translate }}

                      @if (connectionForm.controls.connected.value) {
                        <mat-icon
                          [glxyTooltip]="'AI_ASSISTANT.SETTINGS.TRIGGERS.EXISTING_TRIGGER_TOOLTIP' | translate"
                          class="warning-icon"
                          >warning
                        </mat-icon>
                      }
                    </div>
                  }
                </div>
                @if (connectionForm.metadata.cta?.action?.showButton) {
                  <a
                    (click)="triggerAction(connectionForm.metadata); $event.preventDefault()"
                    class="connections-checkbox-settings-link"
                  >
                    @if (connectionForm.metadata.isDefault && !connectionForm.metadata.cta?.label) {
                      {{
                        'AI_ASSISTANT.SETTINGS.SETUP_TRIGGER'
                          | translate: { connectionName: connectionForm.metadata.name }
                      }}
                    } @else {
                      {{ connectionForm.metadata.cta?.label || 'AI_ASSISTANT.SETTINGS.SETTINGS' | translate }}
                    }
                  </a>
                }
              </div>
            </div>
          </mat-checkbox>
        </glxy-form-field>
        @if (
          connectionForm.metadata.connectionType === ConnectionType.AutoReviewResponse &&
          shouldShowReviewTriggerBanner()
        ) {
          <glxy-alert type="warning">
            <div class="connections-title">{{ reviewTriggerBanner()?.titleKey || '' | translate }}</div>
            <div>{{ reviewTriggerBanner()?.contentKey || '' | translate }}</div>
          </glxy-alert>
        }
      }
      @if (shouldShowToggleButton()) {
        <p
          class="toggle-connections-button"
          [class.toggle-connections-button-view-less-state]="showAllConnections()"
          (click)="toggleShowAllConnections()"
          [attr.aria-expanded]="showAllConnections()"
        >
          {{ toggleButtonText() | translate }}
        </p>
      }
    }
    @for (automation of blueprintAutomations(); track automation.id) {
      <div class="blueprint-automation-row">
        <div class="checkbox-icon-and-label-wrapper">
          <mat-slide-toggle
            [checked]="automation.runningState === RunningState.RUNNING_STATE_RUNNING"
            (change)="onBlueprintAutomationToggle($event, automation)"
          ></mat-slide-toggle>
          <div>
            <div>{{ automation.name }}</div>
            @if (automationIdsWithCustomizableSteps().has(automation.id)) {
              <a
                [routerLink]="['../../../../', 'automations', 'customize', automation.id]"
                class="connections-checkbox-settings-link"
              >
                {{ 'AI_ASSISTANT.SETTINGS.SETTINGS' | translate }}
              </a>
            }
          </div>
        </div>
      </div>
    }
  </mat-card-content>
  @if (showManageButton()) {
    <mat-card-footer class="card-footer">
      <a mat-stroked-button [routerLink]="manageChannelsRoute()">
        {{ 'AI_ASSISTANT.SETTINGS.MANAGE_TRIGGERS' | translate }}
      </a>
    </mat-card-footer>
  }
</mat-card>
